import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import DashboardPage from "./pages/DashboardPage";
import HorseDetailPage from "./pages/HorseDetailPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import BarnChoresPage from "./pages/BarnChoresPage";
import ChatPage from "./pages/ChatPage";
import ReferralPage from "./pages/ReferralPage";
import CalendarPage from "./pages/CalendarPage";
import MarketplacePage from "./pages/MarketplacePage";
import EmergencyPage from "./pages/EmergencyPage";
import BarnBoardPage from "./pages/BarnBoardPage";
import EventsPage from "./pages/EventsPage";
import AcceptSharePage from "./pages/AcceptSharePage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import ReminderSettingsPage from "./pages/ReminderSettingsPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import FriendsPage from "./pages/FriendsPage";
import ProviderDirectoryPage from "./pages/ProviderDirectoryPage";
import "@/App.css";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[#F2F7F4]">
      <div className="animate-pulse text-[#1B4332] font-['Cormorant_Garamond'] text-2xl">Loading...</div>
    </div>
  );
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[#F2F7F4]">
      <div className="animate-pulse text-[#1B4332] font-['Cormorant_Garamond'] text-2xl">Loading...</div>
    </div>
  );

  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to="/dashboard" replace /> : <LandingPage />} />
      <Route path="/auth" element={user ? <Navigate to="/dashboard" replace /> : <AuthPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/horse/:horseId" element={<ProtectedRoute><HorseDetailPage /></ProtectedRoute>} />
      <Route path="/subscription" element={<ProtectedRoute><SubscriptionPage /></ProtectedRoute>} />
      <Route path="/barn-chores" element={<ProtectedRoute><BarnChoresPage /></ProtectedRoute>} />
      <Route path="/chat" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
      <Route path="/chat/:conversationId" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
      <Route path="/calendar" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
      <Route path="/marketplace" element={<ProtectedRoute><MarketplacePage /></ProtectedRoute>} />
      <Route path="/emergency" element={<ProtectedRoute><EmergencyPage /></ProtectedRoute>} />
      <Route path="/events" element={<ProtectedRoute><EventsPage /></ProtectedRoute>} />
      <Route path="/share/:shareCode" element={<ProtectedRoute><AcceptSharePage /></ProtectedRoute>} />
      <Route path="/referral" element={<ProtectedRoute><ReferralPage /></ProtectedRoute>} />
      <Route path="/barn-board" element={<ProtectedRoute><BarnBoardPage /></ProtectedRoute>} />
      <Route path="/reminders" element={<ProtectedRoute><ReminderSettingsPage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboardPage /></ProtectedRoute>} />
      <Route path="/friends" element={<ProtectedRoute><FriendsPage /></ProtectedRoute>} />
      <Route path="/providers" element={<ProtectedRoute><ProviderDirectoryPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster
          theme="light"
          position="top-right"
          toastOptions={{
            style: {
              background: '#FFFFFF',
              border: '1px solid #D1E0D5',
              color: '#122A1F',
              fontFamily: 'Figtree, sans-serif',
            }
          }}
        />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
